module.exports = __webpack_public_path__ + "static/media/forger_of_lisk.eb32c0c7.jpg";